module.exports = {
	"job": {
		"lang": "en",
		"user_id": 46548,
		"name": "jeff_introduction.mp3",
		"duration": 185,
		"created_at": "Fri Jul 27 20:12:08 2018",
		"id": 8856520
	},
	"speakers": [
		{
			"duration": "119.14",
			"confidence": null,
			"name": "M1",
			"time": "1.66"
		},
		{
			"duration": "64.08",
			"confidence": null,
			"name": "M2",
			"time": "120.84"
		}
	],
	"words": [
		{
			"duration": "0.21",
			"confidence": "0.860",
			"name": "All",
			"time": "1.66"
		},
		{
			"duration": "0.39",
			"confidence": "0.990",
			"name": "right",
			"time": "1.88"
		},
		{
			"duration": "0.38",
			"confidence": "0.980",
			"name": ".",
			"time": "2.27"
		},
		{
			"duration": "0.12",
			"confidence": "0.870",
			"name": "I'd",
			"time": "2.66"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "like",
			"time": "2.78"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "2.99"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "introduce",
			"time": "3.11"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "myself",
			"time": "3.56"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "3.95"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "you",
			"time": "4.07"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "my",
			"time": "4.19"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "name",
			"time": "4.34"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "is",
			"time": "4.58"
		},
		{
			"duration": "0.54",
			"confidence": "0.900",
			"name": "Jeff",
			"time": "5.26"
		},
		{
			"duration": "0.10",
			"confidence": "0.570",
			"name": ".",
			"time": "5.81"
		},
		{
			"duration": "0.11",
			"confidence": "0.610",
			"name": "The",
			"time": "5.91"
		},
		{
			"duration": "0.25",
			"confidence": "1.000",
			"name": "hip",
			"time": "6.04"
		},
		{
			"duration": "0.20",
			"confidence": "0.940",
			"name": "hop",
			"time": "6.29"
		},
		{
			"duration": "0.31",
			"confidence": "0.900",
			"name": "dating",
			"time": "6.49"
		},
		{
			"duration": "0.51",
			"confidence": "0.990",
			"name": "coach",
			"time": "6.80"
		},
		{
			"duration": "0.20",
			"confidence": "0.580",
			"name": ".",
			"time": "8.02"
		},
		{
			"duration": "0.19",
			"confidence": "0.550",
			"name": "And",
			"time": "8.46"
		},
		{
			"duration": "0.26",
			"confidence": "1.000",
			"name": "this",
			"time": "8.74"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "is",
			"time": "9.14"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "really",
			"time": "9.29"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "10.07"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "just",
			"time": "10.16"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "want",
			"time": "10.34"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "you",
			"time": "10.55"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "to",
			"time": "10.64"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "get",
			"time": "10.73"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "10.91"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "basic",
			"time": "10.97"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "understanding",
			"time": "11.39"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "of",
			"time": "11.99"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "who",
			"time": "12.05"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "I",
			"time": "12.26"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "am",
			"time": "12.44"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "what",
			"time": "12.68"
		},
		{
			"duration": "0.12",
			"confidence": "0.940",
			"name": "I'm",
			"time": "12.83"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "about",
			"time": "12.95"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "to",
			"time": "13.22"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "embark",
			"time": "13.28"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "on",
			"time": "13.70"
		},
		{
			"duration": "0.12",
			"confidence": "0.990",
			"name": "I'm",
			"time": "14.42"
		},
		{
			"duration": "0.18",
			"confidence": "0.970",
			"name": "going",
			"time": "14.54"
		},
		{
			"duration": "0.06",
			"confidence": "0.970",
			"name": "to",
			"time": "14.72"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "present",
			"time": "14.78"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "a",
			"time": "15.59"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "series",
			"time": "15.68"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "of",
			"time": "16.13"
		},
		{
			"duration": "0.75",
			"confidence": "1.000",
			"name": "videos",
			"time": "16.19"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "17.72"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "help",
			"time": "17.84"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "address",
			"time": "18.11"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "18.74"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "What",
			"time": "19.85"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "I",
			"time": "20.09"
		},
		{
			"duration": "0.75",
			"confidence": "1.000",
			"name": "consider",
			"time": "20.27"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "the",
			"time": "21.68"
		},
		{
			"duration": "0.78",
			"confidence": "1.000",
			"name": "problem",
			"time": "21.80"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "with",
			"time": "23.09"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "dating",
			"time": "23.81"
		},
		{
			"duration": "0.27",
			"confidence": "0.970",
			"name": "and",
			"time": "24.56"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "my",
			"time": "24.83"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "solutions",
			"time": "25.04"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "to",
			"time": "25.67"
		},
		{
			"duration": "1.02",
			"confidence": "1.000",
			"name": "matrimony",
			"time": "26.72"
		},
		{
			"duration": "0.81",
			"confidence": "1.000",
			"name": "problems",
			"time": "27.77"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "teenage",
			"time": "29.24"
		},
		{
			"duration": "0.96",
			"confidence": "1.000",
			"name": "pregnancy",
			"time": "29.72"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "dating",
			"time": "30.98"
		},
		{
			"duration": "0.87",
			"confidence": "1.000",
			"name": "violence",
			"time": "31.34"
		},
		{
			"duration": "0.12",
			"confidence": "0.930",
			"name": "and",
			"time": "33.35"
		},
		{
			"duration": "0.03",
			"confidence": "1.000",
			"name": "a",
			"time": "33.47"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "variety",
			"time": "33.50"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "of",
			"time": "34.07"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "different",
			"time": "34.16"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "things",
			"time": "34.43"
		},
		{
			"duration": "0.07",
			"confidence": "0.770",
			"name": ".",
			"time": "34.82"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "And",
			"time": "34.91"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "I",
			"time": "35.75"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "call",
			"time": "35.87"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "myself",
			"time": "36.11"
		},
		{
			"duration": "0.04",
			"confidence": "0.740",
			"name": "a",
			"time": "36.64"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "hip",
			"time": "36.68"
		},
		{
			"duration": "0.19",
			"confidence": "0.830",
			"name": "hop",
			"time": "36.89"
		},
		{
			"duration": "0.20",
			"confidence": "0.540",
			"name": "daily",
			"time": "37.08"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "coach",
			"time": "37.28"
		},
		{
			"duration": "0.03",
			"confidence": "0.740",
			"name": ".",
			"time": "37.68"
		},
		{
			"duration": "0.23",
			"confidence": "0.930",
			"name": "That's",
			"time": "37.71"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "because",
			"time": "37.94"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "38.21"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "use",
			"time": "38.30"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "hip",
			"time": "38.96"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "hop",
			"time": "39.20"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "to",
			"time": "39.50"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "address",
			"time": "40.28"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "the",
			"time": "40.88"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "middle",
			"time": "41.06"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "ground",
			"time": "41.36"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "of",
			"time": "42.29"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "42.95"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "People",
			"time": "44.19"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "or",
			"time": "44.82"
		},
		{
			"duration": "0.84",
			"confidence": "1.000",
			"name": "society",
			"time": "44.97"
		},
		{
			"duration": "0.26",
			"confidence": "0.960",
			"name": ".",
			"time": "45.84"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "Hip",
			"time": "46.11"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "hop",
			"time": "46.38"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "was",
			"time": "46.71"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "created",
			"time": "47.13"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "by",
			"time": "48.03"
		},
		{
			"duration": "0.03",
			"confidence": "1.000",
			"name": "a",
			"time": "48.30"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "variety",
			"time": "48.33"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "of",
			"time": "49.02"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "ethnic",
			"time": "49.17"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "groups",
			"time": "49.53"
		},
		{
			"duration": "0.09",
			"confidence": "0.810",
			"name": "in",
			"time": "49.86"
		},
		{
			"duration": "0.06",
			"confidence": "0.980",
			"name": "the",
			"time": "49.95"
		},
		{
			"duration": "0.81",
			"confidence": "1.000",
			"name": "African-American",
			"time": "50.01"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "community",
			"time": "50.82"
		},
		{
			"duration": "0.87",
			"confidence": "1.000",
			"name": "Europeans",
			"time": "51.75"
		},
		{
			"duration": "0.84",
			"confidence": "1.000",
			"name": "Latinos",
			"time": "52.89"
		},
		{
			"duration": "0.15",
			"confidence": "0.990",
			"name": "and",
			"time": "53.97"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "even",
			"time": "54.12"
		},
		{
			"duration": "0.42",
			"confidence": "0.890",
			"name": "heavily",
			"time": "54.46"
		},
		{
			"duration": "0.33",
			"confidence": "0.430",
			"name": "flu",
			"time": "54.90"
		},
		{
			"duration": "0.42",
			"confidence": "0.980",
			"name": "infused",
			"time": "55.56"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "by",
			"time": "55.98"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "Asian",
			"time": "56.67"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "culture",
			"time": "56.97"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "with",
			"time": "57.42"
		},
		{
			"duration": "0.06",
			"confidence": "0.990",
			"name": "the",
			"time": "57.60"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "martial",
			"time": "57.66"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "arts",
			"time": "58.05"
		},
		{
			"duration": "0.44",
			"confidence": "1.000",
			"name": "movies",
			"time": "58.26"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "of",
			"time": "58.71"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "course",
			"time": "58.86"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "you",
			"time": "59.55"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "know",
			"time": "59.73"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "you",
			"time": "59.91"
		},
		{
			"duration": "0.24",
			"confidence": "0.980",
			"name": "had",
			"time": "60.15"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "the",
			"time": "60.39"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "pioneering",
			"time": "61.47"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "values",
			"time": "62.16"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "love",
			"time": "62.64"
		},
		{
			"duration": "0.24",
			"confidence": "0.790",
			"name": "peace",
			"time": "62.91"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "and",
			"time": "63.15"
		},
		{
			"duration": "0.33",
			"confidence": "0.990",
			"name": "having",
			"time": "63.27"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "fun",
			"time": "63.60"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "and",
			"time": "64.47"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "really",
			"time": "64.98"
		},
		{
			"duration": "0.21",
			"confidence": "0.900",
			"name": "that",
			"time": "65.22"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "just",
			"time": "65.43"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "65.88"
		},
		{
			"duration": "0.15",
			"confidence": "0.990",
			"name": "To",
			"time": "66.51"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "me",
			"time": "66.66"
		},
		{
			"duration": "0.08",
			"confidence": "0.520",
			"name": ".",
			"time": "67.08"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "Hip",
			"time": "67.23"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "hop",
			"time": "67.47"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "is",
			"time": "67.83"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "a",
			"time": "68.16"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "place",
			"time": "68.25"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "where",
			"time": "68.64"
		},
		{
			"duration": "0.72",
			"confidence": "1.000",
			"name": "race",
			"time": "69.87"
		},
		{
			"duration": "0.57",
			"confidence": "0.980",
			"name": "doesn't",
			"time": "71.04"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "really",
			"time": "71.61"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "matter",
			"time": "72.06"
		},
		{
			"duration": "0.51",
			"confidence": "0.910",
			"name": ".",
			"time": "72.69"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "Culture",
			"time": "73.20"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "is",
			"time": "74.07"
		},
		{
			"duration": "0.64",
			"confidence": "1.000",
			"name": "welcomed",
			"time": "74.34"
		},
		{
			"duration": "0.02",
			"confidence": "0.540",
			"name": ".",
			"time": "74.98"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "So",
			"time": "75.09"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "you",
			"time": "75.27"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "bring",
			"time": "75.45"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "your",
			"time": "75.75"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "cultural",
			"time": "75.93"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "expressions",
			"time": "76.44"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "whether",
			"time": "77.37"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "you're",
			"time": "77.67"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "Arab",
			"time": "78.60"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "you're",
			"time": "79.29"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "Indian",
			"time": "80.19"
		},
		{
			"duration": "0.40",
			"confidence": "0.620",
			"name": "and",
			"time": "81.28"
		},
		{
			"duration": "0.78",
			"confidence": "1.000",
			"name": "Latino",
			"time": "82.71"
		},
		{
			"duration": "0.08",
			"confidence": "0.870",
			"name": ".",
			"time": "83.49"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "We",
			"time": "83.58"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "want",
			"time": "83.82"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "to",
			"time": "84.03"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "hear",
			"time": "84.09"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "how",
			"time": "84.78"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "you",
			"time": "84.96"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "put",
			"time": "85.14"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "your",
			"time": "85.38"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "spin",
			"time": "85.53"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "on",
			"time": "85.98"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "it",
			"time": "86.19"
		},
		{
			"duration": "0.20",
			"confidence": "0.930",
			"name": "so",
			"time": "86.26"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "we",
			"time": "86.46"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "don't",
			"time": "86.64"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "want",
			"time": "86.82"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "you",
			"time": "87.06"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "87.54"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "lose",
			"time": "87.66"
		},
		{
			"duration": "0.12",
			"confidence": "0.930",
			"name": "your",
			"time": "87.96"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "culture",
			"time": "88.08"
		},
		{
			"duration": "0.02",
			"confidence": "0.650",
			"name": ".",
			"time": "88.47"
		},
		{
			"duration": "0.16",
			"confidence": "1.000",
			"name": "We",
			"time": "88.49"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "want",
			"time": "88.65"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "you",
			"time": "88.86"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "to",
			"time": "88.98"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "bring",
			"time": "89.49"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "your",
			"time": "89.73"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "culture",
			"time": "89.88"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "but",
			"time": "90.54"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "your",
			"time": "90.69"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "culture",
			"time": "90.81"
		},
		{
			"duration": "0.15",
			"confidence": "0.990",
			"name": "is",
			"time": "91.17"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "welcome",
			"time": "91.32"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "and",
			"time": "92.10"
		},
		{
			"duration": "0.24",
			"confidence": "0.980",
			"name": "that's",
			"time": "92.34"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "different",
			"time": "92.58"
		},
		{
			"duration": "0.26",
			"confidence": "0.850",
			"name": "than",
			"time": "93.04"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "a",
			"time": "93.36"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "lot",
			"time": "93.45"
		},
		{
			"duration": "0.32",
			"confidence": "1.000",
			"name": "of",
			"time": "93.81"
		},
		{
			"duration": "0.84",
			"confidence": "0.830",
			"name": "subgroups",
			"time": "95.52"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "in",
			"time": "96.48"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "America",
			"time": "97.02"
		},
		{
			"duration": "0.39",
			"confidence": "0.870",
			"name": ".",
			"time": "97.74"
		},
		{
			"duration": "0.12",
			"confidence": "0.980",
			"name": "And",
			"time": "98.19"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "98.31"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "say",
			"time": "98.40"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "that",
			"time": "98.64"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "because",
			"time": "98.82"
		},
		{
			"duration": "0.15",
			"confidence": "0.990",
			"name": "our",
			"time": "99.78"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "subgroups",
			"time": "99.93"
		},
		{
			"duration": "0.47",
			"confidence": "0.970",
			"name": "heavily",
			"time": "100.50"
		},
		{
			"duration": "0.66",
			"confidence": "0.660",
			"name": "influence",
			"time": "100.98"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "us",
			"time": "101.64"
		},
		{
			"duration": "0.25",
			"confidence": "0.570",
			"name": ".",
			"time": "101.99"
		},
		{
			"duration": "0.47",
			"confidence": "1.000",
			"name": "And",
			"time": "102.43"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "102.9"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "When",
			"time": "103.74"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "it",
			"time": "103.89"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "comes",
			"time": "103.98"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "104.28"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "dating",
			"time": "104.40"
		},
		{
			"duration": "0",
			"confidence": "1.000",
			"name": ".",
			"time": "105.03"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "We",
			"time": "106.98"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "get",
			"time": "107.16"
		},
		{
			"duration": "0.36",
			"confidence": "0.970",
			"name": "on",
			"time": "107.37"
		},
		{
			"duration": "0.90",
			"confidence": "0.670",
			"name": "main",
			"time": "107.85"
		},
		{
			"duration": "0.78",
			"confidence": "1.000",
			"name": "influences",
			"time": "108.84"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "from",
			"time": "109.80"
		},
		{
			"duration": "0.09",
			"confidence": "0.690",
			"name": "our",
			"time": "110.07"
		},
		{
			"duration": "0.78",
			"confidence": "1.000",
			"name": "religions",
			"time": "110.16"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "and",
			"time": "111.21"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "our",
			"time": "111.36"
		},
		{
			"duration": "0.64",
			"confidence": "1.000",
			"name": "cultures",
			"time": "111.48"
		},
		{
			"duration": "0.16",
			"confidence": "0.640",
			"name": ".",
			"time": "112.14"
		},
		{
			"duration": "0.18",
			"confidence": "0.980",
			"name": "And",
			"time": "112.38"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "many",
			"time": "112.56"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "of",
			"time": "112.83"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "our",
			"time": "112.98"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "cultures",
			"time": "113.07"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "and",
			"time": "113.58"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "religions",
			"time": "113.67"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "don't",
			"time": "114.63"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "more",
			"time": "116.70"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "so",
			"time": "117.09"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "isolate",
			"time": "118.14"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "us",
			"time": "118.71"
		},
		{
			"duration": "0.30",
			"confidence": "0.970",
			"name": "than",
			"time": "119.28"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "unite",
			"time": "119.58"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "us",
			"time": "120.06"
		},
		{
			"duration": "0.35",
			"confidence": "0.900",
			"name": ".",
			"time": "120.45"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "Many",
			"time": "120.84"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "religions",
			"time": "121.17"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "have",
			"time": "122.04"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "within",
			"time": "122.94"
		},
		{
			"duration": "0.15",
			"confidence": "0.910",
			"name": "their",
			"time": "123.36"
		},
		{
			"duration": "0.78",
			"confidence": "1.000",
			"name": "guidelines",
			"time": "123.51"
		},
		{
			"duration": "0.18",
			"confidence": "0.580",
			"name": ".",
			"time": "124.29"
		},
		{
			"duration": "0.63",
			"confidence": "1.000",
			"name": "Muslims",
			"time": "124.47"
		},
		{
			"duration": "0.23",
			"confidence": "0.980",
			"name": "are",
			"time": "125.10"
		},
		{
			"duration": "0.23",
			"confidence": "1.000",
			"name": "to",
			"time": "125.35"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "date",
			"time": "125.58"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "marry",
			"time": "126.03"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "only",
			"time": "126.75"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "Muslims",
			"time": "127.05"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "Jewish",
			"time": "127.65"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "people",
			"time": "128.13"
		},
		{
			"duration": "0.12",
			"confidence": "0.830",
			"name": "are",
			"time": "128.85"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "128.97"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "date",
			"time": "129.12"
		},
		{
			"duration": "0.41",
			"confidence": "1.000",
			"name": "marry",
			"time": "129.82"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "only",
			"time": "130.29"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "Jewish",
			"time": "130.65"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "people",
			"time": "131.04"
		},
		{
			"duration": "0.09",
			"confidence": "0.680",
			"name": "and",
			"time": "131.45"
		},
		{
			"duration": "0.06",
			"confidence": "0.690",
			"name": "the",
			"time": "131.54"
		},
		{
			"duration": "0.28",
			"confidence": "1.000",
			"name": "same",
			"time": "131.60"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "thing",
			"time": "131.88"
		},
		{
			"duration": "0.16",
			"confidence": "1.000",
			"name": "with",
			"time": "132.21"
		},
		{
			"duration": "0.06",
			"confidence": "0.620",
			"name": "the",
			"time": "132.37"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "different",
			"time": "133.02"
		},
		{
			"duration": "0.72",
			"confidence": "1.000",
			"name": "denominations",
			"time": "133.29"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "of",
			"time": "134.01"
		},
		{
			"duration": "0.81",
			"confidence": "1.000",
			"name": "Christianity",
			"time": "134.13"
		},
		{
			"duration": "0.29",
			"confidence": "0.810",
			"name": ".",
			"time": "134.94"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "And",
			"time": "135.30"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "136.59"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "think",
			"time": "136.68"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "that",
			"time": "136.89"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "is",
			"time": "137.34"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "kind",
			"time": "137.55"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "of",
			"time": "137.82"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "a",
			"time": "138.15"
		},
		{
			"duration": "0.71",
			"confidence": "1.000",
			"name": "problem",
			"time": "138.24"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "but",
			"time": "139.29"
		},
		{
			"duration": "0.14",
			"confidence": "0.860",
			"name": "it's",
			"time": "139.47"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "only",
			"time": "139.62"
		},
		{
			"duration": "0.22",
			"confidence": "1.000",
			"name": "one",
			"time": "139.89"
		},
		{
			"duration": "0.06",
			"confidence": "0.970",
			"name": "of",
			"time": "140.11"
		},
		{
			"duration": "0.08",
			"confidence": "0.470",
			"name": "our",
			"time": "140.17"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "problems",
			"time": "140.25"
		},
		{
			"duration": "0.09",
			"confidence": "0.990",
			"name": ".",
			"time": "140.85"
		},
		{
			"duration": "0.08",
			"confidence": "0.920",
			"name": "All",
			"time": "140.94"
		},
		{
			"duration": "0.28",
			"confidence": "0.920",
			"name": "right",
			"time": "141.02"
		},
		{
			"duration": "0.25",
			"confidence": "0.760",
			"name": ".",
			"time": "141.31"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "I",
			"time": "141.63"
		},
		{
			"duration": "0.33",
			"confidence": "0.970",
			"name": "tried",
			"time": "141.84"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "142.17"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "address",
			"time": "142.32"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "that",
			"time": "142.83"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "by",
			"time": "143.46"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "offering",
			"time": "143.79"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "myself",
			"time": "144.27"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "as",
			"time": "144.69"
		},
		{
			"duration": "0.06",
			"confidence": "0.970",
			"name": "a",
			"time": "144.81"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "hip",
			"time": "144.87"
		},
		{
			"duration": "0.17",
			"confidence": "0.920",
			"name": "hop",
			"time": "145.08"
		},
		{
			"duration": "0.28",
			"confidence": "0.920",
			"name": "dating",
			"time": "145.25"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "coach",
			"time": "145.53"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "so",
			"time": "146.13"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "that",
			"time": "146.25"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "way",
			"time": "146.40"
		},
		{
			"duration": "0.21",
			"confidence": "0.990",
			"name": "I'm",
			"time": "147.36"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "going",
			"time": "147.57"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "for",
			"time": "147.84"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "the",
			"time": "148.17"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "people",
			"time": "148.29"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "who",
			"time": "148.65"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "are",
			"time": "149.46"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "like",
			"time": "149.70"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "most",
			"time": "149.97"
		},
		{
			"duration": "0.72",
			"confidence": "1.000",
			"name": "Americans",
			"time": "150.36"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "see",
			"time": "151.11"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "somebody",
			"time": "151.38"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "they",
			"time": "151.92"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "are",
			"time": "152.16"
		},
		{
			"duration": "0.48",
			"confidence": "1.000",
			"name": "attracted",
			"time": "152.25"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "to",
			"time": "152.73"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "and",
			"time": "153.30"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "would",
			"time": "153.45"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "like",
			"time": "153.63"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "153.84"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "talk",
			"time": "153.96"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "to",
			"time": "154.26"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "them",
			"time": "154.38"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "and",
			"time": "154.98"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "engage",
			"time": "155.19"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "in",
			"time": "155.73"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "a",
			"time": "155.85"
		},
		{
			"duration": "0.78",
			"confidence": "1.000",
			"name": "premarital",
			"time": "156.24"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "dating",
			"time": "157.02"
		},
		{
			"duration": "0.66",
			"confidence": "1.000",
			"name": "process",
			"time": "157.41"
		},
		{
			"duration": "0.18",
			"confidence": "0.840",
			"name": ".",
			"time": "158.10"
		},
		{
			"duration": "0.12",
			"confidence": "0.980",
			"name": "You",
			"time": "158.31"
		},
		{
			"duration": "0.21",
			"confidence": "0.980",
			"name": "know",
			"time": "158.43"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "I",
			"time": "158.67"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "don't",
			"time": "158.76"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "think",
			"time": "159.00"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "everybody",
			"time": "159.33"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "goes",
			"time": "159.84"
		},
		{
			"duration": "0.33",
			"confidence": "1.000",
			"name": "out",
			"time": "160.26"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "to",
			"time": "160.92"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "look",
			"time": "161.16"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "for",
			"time": "161.61"
		},
		{
			"duration": "0.57",
			"confidence": "1.000",
			"name": "somebody",
			"time": "162.03"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "to",
			"time": "162.60"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "marry",
			"time": "162.75"
		},
		{
			"duration": "0.50",
			"confidence": "0.790",
			"name": ".",
			"time": "163.29"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "But",
			"time": "163.95"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "I",
			"time": "164.49"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "think",
			"time": "164.61"
		},
		{
			"duration": "0.24",
			"confidence": "0.990",
			"name": "that's",
			"time": "164.85"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "also",
			"time": "165.15"
		},
		{
			"duration": "0.11",
			"confidence": "0.880",
			"name": "the",
			"time": "165.58"
		},
		{
			"duration": "0.45",
			"confidence": "1.000",
			"name": "problem",
			"time": "165.69"
		},
		{
			"duration": "0.07",
			"confidence": "0.770",
			"name": ".",
			"time": "166.14"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "I",
			"time": "166.23"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "think",
			"time": "166.38"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "that",
			"time": "167.04"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "if",
			"time": "167.31"
		},
		{
			"duration": "0.17",
			"confidence": "0.810",
			"name": "you're",
			"time": "167.58"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "going",
			"time": "167.76"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "to",
			"time": "168.06"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "look",
			"time": "168.24"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "for",
			"time": "168.51"
		},
		{
			"duration": "0.45",
			"confidence": "0.650",
			"name": "booty",
			"time": "168.72"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "or",
			"time": "169.17"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "look",
			"time": "169.29"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "for",
			"time": "169.53"
		},
		{
			"duration": "0.03",
			"confidence": "0.960",
			"name": "a",
			"time": "169.71"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "nice",
			"time": "169.74"
		},
		{
			"duration": "0.69",
			"confidence": "1.000",
			"name": "person",
			"time": "170.10"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "you",
			"time": "171.30"
		},
		{
			"duration": "0.30",
			"confidence": "0.940",
			"name": "need",
			"time": "171.48"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "to",
			"time": "171.78"
		},
		{
			"duration": "0.78",
			"confidence": "1.000",
			"name": "let",
			"time": "171.96"
		},
		{
			"duration": "0.75",
			"confidence": "1.000",
			"name": "marriage",
			"time": "172.74"
		},
		{
			"duration": "0.93",
			"confidence": "1.000",
			"name": "potential",
			"time": "173.49"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "stay",
			"time": "174.60"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "on",
			"time": "174.96"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "175.11"
		},
		{
			"duration": "0.54",
			"confidence": "1.000",
			"name": "table",
			"time": "175.20"
		},
		{
			"duration": "0.11",
			"confidence": "0.660",
			"name": "and",
			"time": "175.96"
		},
		{
			"duration": "0.08",
			"confidence": "1.000",
			"name": "the",
			"time": "176.08"
		},
		{
			"duration": "0.36",
			"confidence": "1.000",
			"name": "moment",
			"time": "176.16"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "that",
			"time": "176.52"
		},
		{
			"duration": "0.15",
			"confidence": "1.000",
			"name": "you",
			"time": "176.73"
		},
		{
			"duration": "0.39",
			"confidence": "1.000",
			"name": "take",
			"time": "176.88"
		},
		{
			"duration": "0.27",
			"confidence": "1.000",
			"name": "that",
			"time": "177.27"
		},
		{
			"duration": "0.24",
			"confidence": "1.000",
			"name": "off",
			"time": "177.63"
		},
		{
			"duration": "0.09",
			"confidence": "1.000",
			"name": "the",
			"time": "177.87"
		},
		{
			"duration": "0.60",
			"confidence": "1.000",
			"name": "table",
			"time": "177.96"
		},
		{
			"duration": "0.12",
			"confidence": "1.000",
			"name": "it",
			"time": "178.74"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "becomes",
			"time": "178.86"
		},
		{
			"duration": "0.06",
			"confidence": "1.000",
			"name": "a",
			"time": "179.28"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "problem",
			"time": "179.34"
		},
		{
			"duration": "0.26",
			"confidence": "0.980",
			"name": ".",
			"time": "179.76"
		},
		{
			"duration": "0.42",
			"confidence": "1.000",
			"name": "So",
			"time": "180.03"
		},
		{
			"duration": "0.29",
			"confidence": "0.850",
			"name": "I'm",
			"time": "181.26"
		},
		{
			"duration": "0.06",
			"confidence": "0.720",
			"name": "a",
			"time": "181.56"
		},
		{
			"duration": "0.21",
			"confidence": "1.000",
			"name": "hip",
			"time": "181.62"
		},
		{
			"duration": "0.18",
			"confidence": "1.000",
			"name": "hop",
			"time": "181.83"
		},
		{
			"duration": "0.30",
			"confidence": "1.000",
			"name": "dating",
			"time": "182.01"
		},
		{
			"duration": "0.51",
			"confidence": "1.000",
			"name": "coach",
			"time": "182.31"
		},
		{
			"duration": "0.00",
			"confidence": "1.000",
			"name": ".",
			"time": "184.92"
		}
	],
	"format": "1.0"
};


//////////////////
// WEBPACK FOOTER
// ./src/jeff_introduction.json
// module id = 27
// module chunks = 0